import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getAvatarStart,
  getAvatarSuccess,
  getAvatarFailed,
} from "../redux/getAvatar";

import { getImageApi } from "core/http/service/personnelInformation";

function* getAvatarWork() {
  try {
    const res = yield call(getImageApi, { type: "PERSIONAL_IMAGE" });

    yield put({
      type: getAvatarSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getAvatarFailed.type,
    });
  }
}

function* watchGetAvatar() {
  yield takeLatest(getAvatarStart.type, getAvatarWork);
}

export default function* getAvatarSaga() {
  yield all([watchGetAvatar()]);
}
